/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createStatisticsSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      padding: 'calc(100% * (120 / 1440)) 0 calc(100% * (127 / 1440))',
      overflow: 'hidden',
    },
    plxStatistics: {
      width: '100%',
    },
    container: {
      maxWidth: '980px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    mapWrapper: {
      position: 'relative',
      width: '100%',
      height: '858px',
    },
    map: {
      position: 'absolute',
      width: 'calc(100% + 299px)',
      height: '100%',
      left: '-151px',
      right: '-148px',
    },
    mapLegend: {
      position: 'absolute',
      maxWidth: '925px',
      margin: '0 auto',
      top: '40%',
      left: '0',
      right: '0',
    },
    mapLegendText: {
      maxWidth: '480px',
      fontSize: '20px',
      '& > i': {
        fontStyle: 'normal',
        transition: 'color 0.2s linear',
        '&:hover': {
          cursor: 'pointer',
          color: theme.palette.secondary.main,
          textDecoration: 'underline',
        },
      },
    },
    title: {
      marginBottom: '40px',
      textAlign: 'center',
    },
    description: {
      color: theme.palette.secondary.main,
      textAlign: 'center',
      marginBottom: '15px',
    },
    statisticsContainer: {
      paddingTop: '51px',
      position: 'absolute',
      left: '0',
      right: '0',
    },
    statisticsItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    statisticsItemTitle: {
      marginBottom: '6px',
    },
    statisticsItemDescription: {
      textTransform: 'uppercase',
      fontSize: '20px',
    },
  }),
);

export { createStatisticsSectionStyles };
